import { render, staticRenderFns } from "./seurantajakso-haku-form.vue?vue&type=template&id=328ddc52&scoped=true&"
import script from "./seurantajakso-haku-form.vue?vue&type=script&lang=ts&"
export * from "./seurantajakso-haku-form.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajakso-haku-form.vue?vue&type=style&index=0&id=328ddc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ddc52",
  null
  
)

export default component.exports